<template>
    <fieldset :disabled="disabled" style="overflow: visible">
        <legend>Общая информация</legend>
        <table class="dataTable mergeTable" style="width:100%;">
            <thead>
                <tr>
                    <th>Старое</th>
                    <th>Актуальное</th>
                    <th>Новое</th>
                </tr>
            </thead>
            <tbody>
                <slot />
            </tbody>
        </table>
    </fieldset>
</template>
<script>

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        }
    }
}
</script>
